<template>
  <Wrapper :team="team">
    <div
      v-if="$page.props.features?.operating || $page.props.features?.guiding"
      class="my-4 space-y-4"
    >
      <div v-if="$page.props.features?.operating">
        <span>Tour Operator Profile</span>
      </div>

      <div v-if="$page.props.features?.guiding">
        <span>Guide Profile</span>
      </div>
    </div>

    <div
      v-else
      class="my-4 space-y-4"
    >
      This team is not activated.
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from './Wrapper.vue';
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    Link,
    Wrapper,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

    };
  },

  methods: {

  },
};
</script>
